import { Svg } from 'components/svg'

export const InfoIcon = () => (
  <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      d="M10.207,20.387a10,10,0,1,1,10-10A10,10,0,0,1,10.207,20.387Zm-8-9.828a8,8,0,1,0,0-.172Zm10,4.828h-3v-4h-1v-2h3v4h1Zm-1-8h-2v-2h2Z"
      transform="translate(1.793 1.613)"
      fill="currentColor"
    />
  </Svg>
)
